/**
 * Bybit timeframe configuration and interval mapping.
 * @see https://bybit-exchange.github.io/docs/v5/market/kline
 */

import {
  registerExchangeTimeframes,
  resolutionToSeconds,
  type TimeframeConfig,
} from '../../lib/timeframes';

/**
 * Bybit supported kline intervals.
 */
export const BYBIT_TIMEFRAMES: TimeframeConfig = {
  native: ['1', '3', '5', '15', '30', '60', '120', '240', '360', '720', 'D', 'W', 'M'],
  synthetic: ['1s'], // Use ticker for 1s
  minIntervalSeconds: 60,
};

// Register with central registry
registerExchangeTimeframes('bybit', BYBIT_TIMEFRAMES);

/**
 * Maps TradingView resolution to Bybit interval format.
 */
export const mapToBybitInterval = (resolution: string): string => {
  const seconds = resolutionToSeconds(resolution);

  if (seconds === 60) return '1';
  if (seconds === 180) return '3';
  if (seconds === 300) return '5';
  if (seconds === 900) return '15';
  if (seconds === 1800) return '30';
  if (seconds === 3600) return '60';
  if (seconds === 7200) return '120';
  if (seconds === 14400) return '240';
  if (seconds === 21600) return '360';
  if (seconds === 43200) return '720';
  if (seconds === 86400) return 'D';
  if (seconds === 604800) return 'W';
  if (seconds === 2592000) return 'M';

  // Default to closest supported interval (round down)
  if (seconds < 180) return '1';
  if (seconds < 300) return '3';
  if (seconds < 900) return '5';
  if (seconds < 1800) return '15';
  if (seconds < 3600) return '30';
  if (seconds < 7200) return '60';
  if (seconds < 14400) return '120';
  if (seconds < 21600) return '240';
  if (seconds < 43200) return '360';
  if (seconds < 86400) return '720';
  if (seconds < 604800) return 'D';
  if (seconds < 2592000) return 'W';

  return 'M';
};
